import { enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG } from "../../common/Dictionaries";
import { 
	SET_FIRST_LOAD,

	SET_CONTRACT_PARTIE_PRESENTATION,

	SET_CONTRACT_PARTIE_LIST,
	SET_CONTRACT_PARTIE_ITEM,

	SET_CONTRACT_PARTIE_SELECTED,
	SET_CONTRACT_PARTIE_SELECTED_ID,
	SET_CONTRACT_SUBPARTIE_SELECTED,
	SET_CONTRACT_SUBPARTIE_SELECTED_ID,

	SET_CONTRACT_PARTIE_PANEL_ITEM_ISOPEN,

	SET_GENERAL_MESSAGE,
	SET_CONTRACT_PARTIE_MESSAGE_LIST,
	SET_CONTRACT_PARTIE_MESSAGE_ITEM,

	SET_CONTRACT_PARTIE_FORM_CONFIG,
	SET_CONTRACT_SUBPARTIE_FORM_CONFIG,
	SET_CONTRACT_POLYNOMY_FORM_CONFIG,
	SET_CONTRACT_PARTIE_LOG,
	ADD_CONTRACT_PARTIE_ITEM,
	ADD_CONTRACT_PARTIE_SUBITEM,
	SET_CONTRACT_PARTIE_SUBITEM,



	ADD_PARTIE_POLINOMY,
	ADD_SUBPARTIE_POLINOMY,
	SET_PARTIE_POLINOMY,
	SET_CONTRACT_PARTIE_FORM_CONFIG_PARTIE_NUMBER,
} from "../actions/PAY/actions";

const initialState = {
	_firsLoad: false,
	_contractPartiesLogs: null,
	_contractPresentation: null,
	
	_contractParties: null,

	_contractPartieSelected: null,
	_contractPartieSelectedId: null,
	
	_contractSubPartieSelected: null,
	_contractSubPartieSelectedId: null,
	
	_generalMessage: null,
	_generalMessageShow: false,
	_contracPartieMessages: null,

	_contractPartieSidePanelsConfig: {
		isPanelInsertPartieOpen: false,
		isPanelViewPartieOpen: false,
		isPanelEditPartieOpen: false,

		isPanelInsertSubPartieOpen: false,
		isPanelViewSubPartieOpen: false,
		isPanelEditSubPartieOpen: false,

		isPanelFinishPartieOpen: false,
	},
	_contractFormPartieConfig: null,
	_contractFormSubPartieConfig: null,
	_contractFormPolynomyConfig: null
};

const contractPartieReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_CONTRACT_PARTIE_LOG:
			return {
				...state,
				_contractPartiesLogs: action.payload
			};

		case SET_CONTRACT_PARTIE_PRESENTATION:
			return {
				...state,
				_contractPresentation: action.payload
			};
		case SET_CONTRACT_PARTIE_LIST:
			return {
				...state,
				_contractParties: action.payload
			};
		case SET_CONTRACT_PARTIE_ITEM:
			return {
				...state,
				_contractParties: state._contractParties.map(item => 
				  	item.id === action.payload.id ? action.payload : item
				)
			};
		case ADD_CONTRACT_PARTIE_ITEM:
			return {
				...state,
				_contractParties: [...state._contractParties, action.payload],
			};
		case SET_CONTRACT_PARTIE_SUBITEM:
			state._contractParties.map(partie => {
				if (partie.iteM_PARTIDA.id === action.payload.partieId) {
					partie.l_SUBPARTIDA.map(subpartie => {
						if (subpartie.iteM_SUBPARTIDA.id === action.payload.contractSubPartie.iteM_SUBPARTIDA.id) {
							subpartie.iteM_SUBPARTIDA = action.payload.contractSubPartie.iteM_SUBPARTIDA
						}
					})
				}
			})
			
			return {
				...state,
				_contractParties: state._contractParties,
			};
		case ADD_CONTRACT_PARTIE_SUBITEM:
			state._contractParties.map(partie => {
				if (partie.iteM_PARTIDA.id === action.payload.partieId) {
					partie.l_SUBPARTIDA.push(action.payload.contractSubPartie.iteM_SUBPARTIDA)
				}
			})
			
			return {
				...state,
				_contractParties: state._contractParties,
			};
		case SET_CONTRACT_PARTIE_SELECTED:
			return {
				...state,
				_contractPartieSelected: action.payload
			};
		case SET_CONTRACT_PARTIE_SELECTED_ID:
			return {
				...state,
				_contractPartieSelectedId: action.payload
			};
		case SET_CONTRACT_SUBPARTIE_SELECTED:
			return {
				...state,
				_contractSubPartieSelected: action.payload
			};
		case SET_CONTRACT_SUBPARTIE_SELECTED_ID:
			return {
				...state,
				_contractSubPartieSelectedId: action.payload
			};
		case SET_FIRST_LOAD:
			return {
				...state,
				_firsLoad: action.payload
			};
		case SET_GENERAL_MESSAGE:
			return {
				...state,
				_generalMessage: action.payload.message,
				_generalMessageShow: action.payload.show
			};
		case SET_CONTRACT_PARTIE_MESSAGE_LIST:
			return {
				...state,
				_contracPartieMessages: action.payload
			};
		case SET_CONTRACT_PARTIE_MESSAGE_ITEM:
			return {
				...state,
				_contracPartieMessages: state._contracPartieMessages.map(item => 
						item.contractPartieId === action.payload.contractPartieId ? action.payload : item
				)
			};
		
		case SET_CONTRACT_PARTIE_PANEL_ITEM_ISOPEN:
			switch (action.payload.type) {
				case enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_PARTIE_FINISH:
					return {
						...state,
						_contractPartieSidePanelsConfig: {
							...state._contractPartieSidePanelsConfig,
							isPanelFinishPartieOpen: action.payload.isOpen,

							isPanelInsertPartieOpen: state._contractPartieSidePanelsConfig.isPanelInsertPartieOpen,
							isPanelViewPartieOpen: state._contractPartieSidePanelsConfig.isPanelViewPartieOpen,
							isPanelEditPartieOpen: state._contractPartieSidePanelsConfig.isPanelEditPartieOpen,

							isPanelInsertSubPartieOpen: state._contractPartieSidePanelsConfig.isPanelInsertSubPartieOpen,
							isPanelViewSubPartieOpen: state._contractPartieSidePanelsConfig.isPanelViewSubPartieOpen,
							isPanelEditSubPartieOpen: state._contractPartieSidePanelsConfig.isPanelEditSubPartieOpen,
						}
					};
					break;
				case enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_PARTIE_INSERT:
					return {
						...state,
						_contractPartieSidePanelsConfig: {
							...state._contractPartieSidePanelsConfig,
							isPanelFinishPartieOpen: state._contractPartieSidePanelsConfig.isPanelFinishPartieOpen,

							isPanelInsertPartieOpen: action.payload.isOpen,
							isPanelViewPartieOpen: state._contractPartieSidePanelsConfig.isPanelViewPartieOpen,
							isPanelEditPartieOpen: state._contractPartieSidePanelsConfig.isPanelEditPartieOpen,

							isPanelInsertSubPartieOpen: state._contractPartieSidePanelsConfig.isPanelInsertSubPartieOpen,
							isPanelViewSubPartieOpen: state._contractPartieSidePanelsConfig.isPanelViewSubPartieOpen,
							isPanelEditSubPartieOpen: state._contractPartieSidePanelsConfig.isPanelEditSubPartieOpen,
						}
					};
					break;
				case enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_PARTIE_VIEW:
					return {
						...state,
						_contractPartieSidePanelsConfig: {
							...state._contractPartieSidePanelsConfig,
							isPanelFinishPartieOpen: state._contractPartieSidePanelsConfig.isPanelFinishPartieOpen,

							isPanelInsertPartieOpen: state._contractPartieSidePanelsConfig.isPanelInsertPartieOpen,
							isPanelViewPartieOpen: action.payload.isOpen,
							isPanelEditPartieOpen: state._contractPartieSidePanelsConfig.isPanelEditPartieOpen,

							isPanelInsertSubPartieOpen: state._contractPartieSidePanelsConfig.isPanelInsertSubPartieOpen,
							isPanelViewSubPartieOpen: state._contractPartieSidePanelsConfig.isPanelViewSubPartieOpen,
							isPanelEditSubPartieOpen: state._contractPartieSidePanelsConfig.isPanelEditSubPartieOpen,
						}
					};
					break;
				case enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_PARTIE_EDIT:
					return {
						...state,
						_contractPartieSidePanelsConfig: {
							...state._contractPartieSidePanelsConfig,
							isPanelFinishPartieOpen: state._contractPartieSidePanelsConfig.isPanelFinishPartieOpen,

							isPanelInsertPartieOpen: state._contractPartieSidePanelsConfig.isPanelInsertPartieOpen,
							isPanelViewPartieOpen: state._contractPartieSidePanelsConfig.isPanelViewPartieOpen,
							isPanelEditPartieOpen: action.payload.isOpen,

							isPanelInsertSubPartieOpen: state._contractPartieSidePanelsConfig.isPanelInsertSubPartieOpen,
							isPanelViewSubPartieOpen: state._contractPartieSidePanelsConfig.isPanelViewSubPartieOpen,
							isPanelEditSubPartieOpen: state._contractPartieSidePanelsConfig.isPanelEditSubPartieOpen,
						}
					};
					break;
				case enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_SUBPARTIE_INSERT:
					return {
						...state,
						_contractPartieSidePanelsConfig: {
							...state._contractPartieSidePanelsConfig,
							isPanelFinishPartieOpen: state._contractPartieSidePanelsConfig.isPanelFinishPartieOpen,

							isPanelInsertPartieOpen: state._contractPartieSidePanelsConfig.isPanelInsertPartieOpen,
							isPanelViewPartieOpen: state._contractPartieSidePanelsConfig.isPanelViewPartieOpen,
							isPanelEditPartieOpen: state._contractPartieSidePanelsConfig.isPanelEditPartieOpen,
							
							isPanelInsertSubPartieOpen: action.payload.isOpen,
							isPanelViewSubPartieOpen: state._contractPartieSidePanelsConfig.isPanelViewSubPartieOpen,
							isPanelEditSubPartieOpen: state._contractPartieSidePanelsConfig.isPanelEditSubPartieOpen,
						}
					};
					break;
				case enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_SUBPARTIE_VIEW:
					return {
						...state,
						_contractPartieSidePanelsConfig: {
							...state._contractPartieSidePanelsConfig,
							isPanelFinishPartieOpen: state._contractPartieSidePanelsConfig.isPanelFinishPartieOpen,

							isPanelInsertPartieOpen: state._contractPartieSidePanelsConfig.isPanelInsertPartieOpen,
							isPanelViewPartieOpen: state._contractPartieSidePanelsConfig.isPanelViewPartieOpen,
							isPanelEditPartieOpen: state._contractPartieSidePanelsConfig.isPanelEditPartieOpen,

							isPanelInsertSubPartieOpen: state._contractPartieSidePanelsConfig.isPanelInsertSubPartieOpen,
							isPanelViewSubPartieOpen: action.payload.isOpen,
							isPanelEditSubPartieOpen: state._contractPartieSidePanelsConfig.isPanelEditSubPartieOpen,
						}
					};
					break;
				case enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_SUBPARTIE_EDIT:
					return {
						...state,
						_contractPartieSidePanelsConfig: {
							...state._contractPartieSidePanelsConfig,
							isPanelFinishPartieOpen: state._contractPartieSidePanelsConfig.isPanelFinishPartieOpen,

							isPanelInsertPartieOpen: state._contractPartieSidePanelsConfig.isPanelInsertPartieOpen,
							isPanelViewPartieOpen: state._contractPartieSidePanelsConfig.isPanelViewPartieOpen,
							isPanelEditPartieOpen: state._contractPartieSidePanelsConfig.isPanelEditPartieOpen,

							isPanelInsertSubPartieOpen: state._contractPartieSidePanelsConfig.isPanelInsertSubPartieOpen,
							isPanelViewSubPartieOpen: state._contractPartieSidePanelsConfig.isPanelViewSubPartieOpen,
							isPanelEditSubPartieOpen: action.payload.isOpen,
						}
					};
					break;
				default:
					break;
			};
		case SET_CONTRACT_PARTIE_FORM_CONFIG:
			return {
				...state,
				_contractFormPartieConfig: action.payload
			};
		case SET_CONTRACT_PARTIE_FORM_CONFIG_PARTIE_NUMBER:
			return {
				...state,
				_contractFormPartieConfig: {
					...state._contractFormPartieConfig,
					nro_ccorrelativo: action.payload,
				}
			};
		case SET_CONTRACT_SUBPARTIE_FORM_CONFIG:
			return {
				...state,
				_contractFormSubPartieConfig: action.payload
			};
			
		case SET_CONTRACT_POLYNOMY_FORM_CONFIG:
			return {
				...state,
				_contractFormPolynomyConfig: action.payload
			};

			


		case ADD_PARTIE_POLINOMY:
			state._contractParties.map(partie => {
				if (partie.iteM_PARTIDA.id === action.payload.partieId) {
					partie.l_POLINOMIO.push(action.payload.polinomio)
				}
			});
			
			return {
				...state,
				_contractParties: state._contractParties,
			};
		case ADD_SUBPARTIE_POLINOMY:
			state._contractParties.map(partie => {

				if (partie.iteM_PARTIDA.id === action.payload.partieId) {
					partie.l_POLINOMIO.push(action.payload.polinomio)
				}
			});
			
			return {
				...state,
				_contractParties: state._contractParties,
			};
		case SET_PARTIE_POLINOMY:
			state._contractParties.map(partie => {
				if (partie.iteM_PARTIDA.id === action.payload.partieId) {
					partie.l_POLINOMIO.map(polinomio => {
						if (polinomio.id === action.payload.polinomio.id) {
							polinomio = action.payload.polinomio
						}
					})
				}
			});
		default:
			return state;
	}
};



export default contractPartieReducer;